/**
 * 解决VUE不能对新增属性监测更新
 */
export default (old, newAdd) => Object.assign({}, old, newAdd);



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/refreshObj.js